// Grabar audios para el asistente, como una nota de voz de WhatsApp. El audio viaja a n8n,
// que lo pasa a texto antes de mandárselo a la IA.

export const MAX_AUDIO_SECONDS = 60;
// Menos que esto es un toque sin querer: no se manda.
export const MIN_AUDIO_MS = 700;

// Formatos que entiende la transcripción de OpenAI, en orden de preferencia.
const TYPES = ["audio/webm;codecs=opus", "audio/webm", "audio/mp4", "audio/ogg;codecs=opus", "audio/ogg"];

export const canRecord = () => typeof window !== "undefined"
    && typeof window.MediaRecorder !== "undefined"
    && !!navigator.mediaDevices?.getUserMedia;

const pickType = () => TYPES.find((t) => window.MediaRecorder.isTypeSupported?.(t)) || "";

// "0:07", "1:00"
export const clock = (ms) => {
    const s = Math.max(0, Math.round(ms / 1000));
    return Math.floor(s / 60) + ":" + String(s % 60).padStart(2, "0");
}

// Empieza a grabar. Devuelve { stop, cancel }: stop() resuelve con { blob, type, ms }.
// Tira un Error con un mensaje para el dueño si no hay permiso o micrófono.
export const startRecording = async () => {
    let stream;
    try {
        stream = await navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true } });
    } catch (error) {
        if (error.name === "NotAllowedError" || error.name === "SecurityError") {
            throw new Error("Para mandar audios, permití el uso del micrófono en tu navegador.");
        }
        throw new Error("No encontramos un micrófono para grabar.");
    }
    const mimeType = pickType();
    const recorder = new window.MediaRecorder(stream, mimeType ? { mimeType, audioBitsPerSecond: 32000 } : undefined);
    const chunks = [];
    const startedAt = Date.now();
    recorder.ondataavailable = (e) => e.data && e.data.size && chunks.push(e.data);
    const done = new Promise((resolve) => { recorder.onstop = resolve; });
    recorder.start(250);

    const release = () => stream.getTracks().forEach((t) => t.stop());
    const finish = async () => {
        if (recorder.state !== "inactive") recorder.stop();
        await done;
        release();
    };
    return {
        startedAt,
        stop: async () => {
            await finish();
            const type = (recorder.mimeType || mimeType || "audio/webm").split(";")[0];
            return { blob: new Blob(chunks, { type }), type, ms: Date.now() - startedAt };
        },
        cancel: () => { finish(); }
    };
}

export const blobToBase64 = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(",")[1] || "");
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
});
